export default __webpack_public_path__ + "static/media/linkedin.d9361a90.svg";